var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{staticStyle:{"max-width":"50%"},attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('Balance',{attrs:{"msg":"Welcome"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }